import React from "react";

export const Footer = () => {
  const TERMS_URL =
    "https://www.roadmaptofreedom.co/thebarstoolmethodtermsandconditions";

  return (
    <footer className="relative z-10 border-t border-white/10 mt-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center space-y-5 text-xs text-zinc-500">
        <div className="text-zinc-400 font-medium">
          BuddyPass AI™ · Open → Generate → Post → Repeat
        </div>

        <div className="border-t border-white/5 pt-6 space-y-4 text-[11px] leading-relaxed text-zinc-500">
          <div className="flex flex-col items-center gap-2 pt-2">
            <div className="text-zinc-400">
              © Buddy Pass A.I. | Copyright 2026
            </div>
            <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
              <a
                href={TERMS_URL}
                target="_blank"
                rel="noreferrer"
                className="hover:text-amber-400 underline underline-offset-2"
              >
                Privacy Policy
              </a>
              <span>|</span>
              <a
                href={TERMS_URL}
                target="_blank"
                rel="noreferrer"
                className="hover:text-amber-400 underline underline-offset-2"
              >
                Terms &amp; Conditions
              </a>
              <span>|</span>
              <a
                href={TERMS_URL}
                target="_blank"
                rel="noreferrer"
                className="hover:text-amber-400 underline underline-offset-2"
              >
                Affiliate Disclaimer
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
